<template>
  <div class="row">
      <div class="col-md-7">
        <h1>Unsubscribe</h1>
        <hr />
        <form @submit.prevent="unsubscribe" v-if="!success">
          <div class="form-group">
            <label for="">Email Address</label>
            <input type="email" class="form-control" placeholder="Enter Email" v-model="email">
          </div>
          <div class="form-group">
            <label for="">Reason</label>
            <select class="form-control" v-model="reason">
              <option value="employed">I already have a job</option>
              <option value="retired">I'm retired</option>
              <option value="other_service">I prefer another job search service</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div class="form-group" v-if="reason === 'other'">
            <textarea class="form-control" placeholder="Enter Reason" rows="3" v-model="otherReason"></textarea>
          </div>
          <div class="form-group" v-if="reason === 'other_service'">
            <input class="form-control" placeholder="Which Service?" type="text" v-model="otherService" />
          </div>
          <button type="submit" class="btn btn-primary" :disabled="disableSubmit" v-bind:class="{disabled: disableSubmit}">Submit</button>
        </form>
        <div class="alert alert-success" role="alert" v-if="success">
          <h4>We're sorry to see you go :D</h4>
          Please allow up to 48 hours for us to completely fulfill your unsubscribe request. If you have any other questions please <a href="#" @click.prevent="openSupportForm">Contact Us</a>.
        </div>
        <div class="alert alert-danger" role="alert" v-if="error">
          <h4>Whoops...</h4>
          It looks like we had a problem unsubscribing you right now. Please try to submit the form again and if the error persists, <a href="#" @click.prevent="openSupportForm">Contact Us</a>.
        </div>
        <hr>
        <div class="font-weight-bold">
          {{site.address.line1}}<br>
          {{site.address.line2}}<br>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Contact',
  data () {
    return {
      email: this.$store.state.user.email || '',
      reason: 'employed',
      otherService: null,
      otherReason: null,
      error: false,
      success: false,
      disableSubmit: false
    };
  },
  methods: {
    unsubscribe () {
      this.disableSubmit = true;
      this.error = false;
      this.success = false;
      let reason = this.reason;
      switch (reason)
      {
        case 'other_service':
          reason += ' ' + this.otherService;
        break;
        case 'other':
          reason += ' ' + this.otherReason;
        break;
        default: 
      }
      axios.delete(
        process.env.VUE_APP_METRICS_API + '/subscription/' + this.email,
        {
          data: {
            user: {
              pid: 'LMJO',
              reason: reason.trim()
            }
          }
        }
      ).then(res => {
        if (res.data.success) {
          this.success = true;
        } else {
          this.error = true;
          this.disableSubmit = false;
        }
      }).catch(e => {
        if (e.response.status == 404) {
          this.success = true;
        } else {
          this.error = true;
          this.disableSubmit = false;
        }
      });
    }
  }
}
</script>

<style scoped>
  .alert {
    margin-top: 20px;
  }

  select.form-control {
    border: 1px solid #ced4da;
  }
</style>
